import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AudioProvider } from "./context/AudioContext";
import { AuthProvider } from "./context/AuthContext";
import AuthCallback from "./components/AuthCallback";
import Saved from "./pages/Saved";
import Admin from "./pages/Admin";
import Fragments from "./pages/Fragments";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import MiniPlayer from "./components/MiniPlayer";
import Home from "./pages/Home";
import Explore from "./pages/Explore";
import Piece from "./pages/Piece";
import Listen from "./pages/Listen";
import Subscribe from "./pages/Subscribe";
import NotFound from "./pages/NotFound";

let lenis = null;

function SmoothScroll() {
  const { pathname } = useLocation();
  useEffect(() => {
    lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); lenis = null; };
  }, []);
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/explore" element={<Explore />} />
      <Route path="/explore/:slug" element={<Piece />} />
      <Route path="/listen" element={<Listen />} />
      <Route path="/subscribe" element={<Subscribe />} />
      <Route path="/saved" element={<Saved />} />
      <Route path="/fragments" element={<Fragments />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
        <AudioProvider>
          <SmoothScroll />
          <div className="grain" aria-hidden="true" />
          <Nav />
          <main>
            <AppRoutes />
          </main>
          <Footer />
          <MiniPlayer />
          <Toaster position="top-center" toastOptions={{ style: { background: "#141412", color: "#ecebe6", border: "1px solid rgba(236,235,230,.14)", borderRadius: 0, fontFamily: "Newsreader, serif", fontSize: "16px" } }} />
        </AudioProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
